import { createAsyncThunk } from '@reduxjs/toolkit'
import TrimmedMedia from './trimmed-media-model'
import {
  delete_trimmedMedia,
  load_trimmedMedias,
  store_trimmedMedia,
} from './trimmedMedia-service'

export const LoadTrimmedMediasAsync = createAsyncThunk<any, any>(
  'composer/load/trimmedMedia',
  async (params: { uid: string }) => {
    return await load_trimmedMedias(params)
  },
)

export const CreateTrimmedMediaAsync = createAsyncThunk<any, any>(
  'composer/create/trimmedMedia',
  async (params: TrimmedMedia) => {
    return await store_trimmedMedia(params)
  },
)

export const DeleteTrimmedMediaAsync = createAsyncThunk<any, any>(
  'composer/delete/trimmedMedia',
  async (params) => {
    return await delete_trimmedMedia(params)
  },
)
